/*
    模块组件
    ChenYN

    说明
    主页底部切换栏

    版本
    1.0

    传参
        commentData Object : 必填 评论列表
        type String : 非必填 当前组件状态 default = 评论帖子； comment = 评论评论
        isLikesFun Function : 非必填 点赞事件
        deleteComment Function : 非必填 删除当前评论
    依赖
    /style/2019/h5/css/common.css
    vue.js
    vant
    import ForumHead from '@/components/Seven_ForumHead/ForumHead.vue';
    import ForumFoot from '@/components/Seven_ForumFoot/ForumFoot.vue';

    案例
    <demo></demo>
*/
<template>
    <div class="comment_wrap">
        <forum-head :delFun="delComment" :showDel="commentData.user.user_id == userInfo.user_id" :user="commentData.user" type="pure"></forum-head>
        <div class="icon_box" @click.stop="userLike">
            <img v-if="commentData.user_like == 0" src="@/assets/images/atmosphere/like_d.png" alt="">
            <img v-else src="@/assets/images/atmosphere/like_a.png" alt="">
            <span class="num" v-if="commentData.likes && commentData.likes > 0">{{commentData.likes || 0}}</span>
        </div>
        <div class="user_comment">
            <span class="ct_txt">{{util.encodeContent(commentData.content)}}</span>
            <!-- <span class="view_img" v-if="commentData.image" @click.stop="viewImage(commentData.image)">查看图片</span> -->
            <div class="img_wrap" v-if="commentData.image">
                <image-handle :images="[commentData.image]"></image-handle>
            </div>
        </div>
        <div class="reply_wrap" v-if="replyListTotal && replyListTotal.length > 0">
            <div class="reply_item" v-for="v in replyList" :key="v.rid" @click.stop="clickReply(v)">
                <div class="head">
                    <div class="info">{{v.user.nickname}} <span>{{util.showTime(v.created_at)}}</span></div>
                    <div class="head_icon_box" @click.stop="replyUserLike(v)">
                        <img v-if="v.user_like == 0" src="@/assets/images/atmosphere/like_d.png" alt="">
                        <img v-else src="@/assets/images/atmosphere/like_a.png" alt="">
                        <span class="num" v-if="v.likes && v.likes > 0">{{v.likes || 0}}</span>
                    </div>
                </div>

                {{v.content}}
                <!-- <span class="txt">
                    <span class="view_img" v-if="v.image" @click.stop="viewImage(v.image)">查看图片</span>
                </span> -->
                <div class="img_wrap" v-if="v.image">
                    <image-handle :images="[v.image]"></image-handle>
                </div>

                <!-- <span class="name">{{v.user.nickname}}：</span>
                <span class="txt">
                    <span class="van-multi-ellipsis--l2">{{v.content}}</span>
                    <span class="view_img" v-if="v.image" @click.stop="viewImage(v.image)">查看图片</span>
                </span> -->
            </div>

            <div class="showMoreReply" v-if="replyListTotal.length > replyList.length" @click.stop="showMoreReply">展开更多回复</div>

            <!-- <div class="reply_more" @click.stop="goState({name: 'commentlist', params: {id: commentData.tid, pid: commentData.pid}})"><span>全部{{commentData.posts}}条回复</span> <img src="@/assets/images/forum/icon_more_reply.png" alt=""></div> -->
        </div>
        <div class="like_posts_date">
            <!-- <forum-foot :commentFun="userComment" :likeFun="userLike" :userLike="commentData.user_like" :posts="commentData.posts" :likes="commentData.likes"></forum-foot> -->
            <span class="date">{{commentData.created_at ? util.timeHandle(commentData.created_at) : '00:00'}}</span>
        </div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, computed } from 'vue';
import { ImagePreview  } from "vant"
import ImageHandle from '@/components/Seven_ImageHandle/ImageHandle.vue';
import ForumHead from '@/components/Seven_ForumHead/ForumHead.vue';
import ForumFoot from '@/components/Seven_ForumFoot/ForumFoot.vue';
import Util from '@/assets/js/lib/util';
import router from '@/router';
import { useStore } from 'vuex';

export default defineComponent({
    name: 'CommentModel',
    components: { ForumHead, ForumFoot, ImageHandle },
    props: {
        commentData: {
            type: Object,
            default: {}
        },
        type: {
            type: String,
            default: 'default'
        },
        isLikesFun: {
            type: Function
        },
        deleteComment: {
            type: Function
        },
        showMenuPop2: {
            type: Function
        },
    },
    setup(props,{ emit }) {
        const store = useStore();

        const state = reactive({
            util: new Util(),
            nums: 1,
            index: 2,
            replyList: [],
            replyListTotal: [],
            page: 1,
            limit: 100,

        });

        onMounted(async () => {
            reqCommentList();
        });

        const reqCommentList = async (flag = false) => { //请求回复列表
            let params = {
                tid: props.commentData.tid,
                pid: props.commentData.pid,
                page: state.page,
                per_page: state.limit,
                sort: 1,
            }
            const res = await state.util.getJson('/thread/replyList', 'GET', params, true);
            if(res.code == 0){
                state.replyListTotal = res.data.comment.replies;
                if(state.replyListTotal) {
                    state.replyList = state.replyListTotal.slice(0, 2);
                }

                // if(flag){ //加载更多
                //     data.replies.push(...res.data.comment.replies);
                // }else{ //刷新
                //     data.replies = res.data.comment.replies;
                // }

                // state.page += 1;
                // if(res.data.total > 1){
                //     state.total = res.data.total;
                // };
                // setTimeout(() => {
                //     state.bs.refresh();
                // }, 300);
            }else {
                window.Components.toast(res.msg)
            }
        }

        const methods = {
            back: () => router.back(),
            goState: o => router.push(o),
            userLike: async () => {
                if (!state.util.getCookieLocalStorage('access_token')) {
                    state.util.login({ query: { routerurl: router?.options?.history?.state?.current } }, 'replace')
                    return false;
                }
                if(props.isLikesFun){
                    props.isLikesFun({
                        tid: props.commentData.tid,
                        type: props.type == 'comment' ? 3 : 2,
                        status: props.commentData.user_like == 0 ? 1 : 0,
                        comment_id: props.type == 'comment' ? props.commentData.rid :  props.commentData.pid
                    })
                }
            },
            replyUserLike: async (item) => {
                if (!state.util.getCookieLocalStorage('access_token')) {
                    state.util.login({ query: { routerurl: router?.options?.history?.state?.current } }, 'replace')
                    return false;
                }
                let params = {
                    tid: item.tid,
                    type: 3,
                    status: item.user_like == 0 ? 1 : 0,
                    comment_id: item.rid
                }
                const res = await state.util.getJson('/thread/like', 'POST', params, true);
                if(res.code == 0){
                    if(item.user_like) {
                        //更新虚假取消点赞
                        item.user_like = item.user_like == 0 ? 1 : 0;
                        item.likes = item.likes - 1;
                    }else {
                        //更新虚假点赞
                        item.user_like = item.user_like == 0 ? 1 : 0;
                        item.likes = item.likes + 1;
                    }
                }else {
                    window.Components.toast(res.msg)
                }
            },
            userComment: () => {
                if(props.type == 'comment'){
                    emit('commentModelBtn',{type: 'replyUser', id: props.commentData.rid})
                }else {
                    emit('commentModelBtn',{type: 'reply', id: props.commentData.pid})
                }

            },
            viewImage: (img) => {
                ImagePreview({
                    images: [img],
                    closeable: true,
                });
            },
            delComment: () => { //删除当前评论
                if(props.deleteComment){
                    props.deleteComment(props.commentData);
                }
            },
            showMoreReply: () => {
                //展开更多
                if(state.replyListTotal.length > state.replyList.length) {
                    let index = 2 + 5 * state.nums;
                    state.replyList = state.replyListTotal.slice(0, index)
                    state.nums = state.nums + 1;
                    emit('commentModelRefresh')
                }
            },
            clickReply: (item) => {
                //回复回复
                props.showMenuPop2(item)
            }
        } //需要对外暴露的方法
        return {
            ...toRefs(state),
            ...methods,
            userInfo: computed(() => store.state.userInfo),
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./CommentModel.less";
</style>